import LanguagePack from "../../../../../shared/lib/html5-software-library/src/ranj/language/LanguagePack";
import Anchor from "../../../../../shared/lib/html5-software-library/src/ranj/layout/Anchor";
import GameEvent from "../../../../../shared/src/ranj/app/core/GameEvent";
import AbstractScreenMediator from "../../../../../shared/src/ranj/app/ui/AbstractScreenMediator";

export default class EndScreenMediator extends AbstractScreenMediator {

    /**
     * @param {createjs.DisplayObject} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LanguagePack} languagePack 
     * @param {*} layoutManager 
     * @param {*} soundManager 
     * @param {*} gameAssets  
     */
     constructor(target, dispatcher, languagePack, layoutManager, soundManager) {
        super(target, dispatcher, languagePack, layoutManager, soundManager);
    }

    initialize() {
        super.initialize();

        this._target.titleTextfield.text = this.getText("end.title");
        this._target.bodyTextfield.text = this.getText("end.body");

        this._button = this.createButton(this._target.button, this._handleButtonClick.bind(this), this.getText("end.button"));
        
        this.anchorObject(this._target.titleTextfield, Anchor.T);
        this.anchorObject(this._target.bodyTextfield, Anchor.T);
    }

    _handleButtonClick(e) {
        this._button.setEnabled(false);
        this.dispatch(GameEvent.EXIT);
    }
}
